export const esUsuarioVip = () => {
  return Boolean(Number(localStorage.getItem("vip")));
};

export const filtrarSucursalesAutorizadas = (sucursales) => {
  if (esUsuarioVip()) {
    return sucursales;
  }
  const sucAuth = (localStorage.getItem("suc_auth") || "")
    .split(",")
    .map((id) => id.trim());
  return sucursales.filter((sucursal) =>
    sucAuth.includes(String(sucursal.id_suc))
  );
};
